var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#a2a5b9",
    cx: 21,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#a2a5b9",
    cx: 21,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#a2a5b9",
    cx: 21,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#a2a5b9",
    cx: 21,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#a2a5b9",
    cx: 21,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a5b9",
    d: "M29,19v6h-4V15h-8v6h-6v16H8c-0.552,0-1,0.447-1,1s0.448,1,1,1h3h6h2h4h2h4h2h4h2h4h2h6h3c0.552,0,1-0.447,1-1 s-0.448-1-1-1h-3V15h-6v-3h-8v7H29z M13,37V23h4v14H13z M20,37c0-0.552-0.448-1-1-1v-2c0.552,0,1-0.448,1-1s-0.448-1-1-1v-2 c0.552,0,1-0.448,1-1s-0.448-1-1-1v-2c0.552,0,1-0.448,1-1s-0.448-1-1-1v-2c0.552,0,1-0.448,1-1s-0.448-1-1-1v-2 c0.552,0,1-0.448,1-1h2c0,0.552,0.448,1,1,1v2c-0.552,0-1,0.448-1,1s0.448,1,1,1v2c-0.552,0-1,0.448-1,1s0.448,1,1,1v2 c-0.552,0-1,0.448-1,1s0.448,1,1,1v2c-0.552,0-1,0.448-1,1s0.448,1,1,1v2c-0.552,0-1,0.448-1,1H20z M25,37V27h4v10H25z M31,37V25 v-4h4v16H31z M47,17v20h-4V17H47z M37,14h4v1v22h-4V19V14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a5b9",
    d: "M60,4H31V1c0-0.553-0.448-1-1-1s-1,0.447-1,1v3H0v42h27.586L15.293,58.293c-0.391,0.391-0.391,1.023,0,1.414 C15.488,59.902,15.744,60,16,60s0.512-0.098,0.707-0.293L29,47.414V57c0,0.553,0.448,1,1,1s1-0.447,1-1v-9.586l12.293,12.293 C43.488,59.902,43.744,60,44,60s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L32.414,46H60V4z M58,44H2V6h56V44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.b22b556a674193b926b93309dbd5b35e.svg";
export { ForwardRef as ReactComponent };